import { render, staticRenderFns } from "./RouterManager.vue?vue&type=template&id=a4c33978&scoped=true&"
import script from "./RouterManager.vue?vue&type=script&lang=js&"
export * from "./RouterManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c33978",
  null
  
)

export default component.exports